import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { filter, permissions as permissionDeco } from 'helpers/decorators'
import { Input, Select } from 'components/fields'
import { Module, Row, Col, FilterActions } from 'components/misc'
import { participants as participantsApi } from 'redux/modules/api'
import { awardStatesFilterSelector } from 'redux/selectors/awards'
import {
  apiCodeLists,
  apiLeaders,
  apiOrganizations,
  apiLabels,
  apiConfiguration,
  apiActivities
} from 'helpers/decorators/api'
import { mapLeaders, mapAwardUnits, mapLabels } from 'helpers/mapForSelect'
import { injectIntl } from 'react-intl'
import { ORGANIZATION_HIERARCHY, LABEL_CATEGORY_TYPES } from 'constants/enums'
import { CONFIGURATION_KEYS } from '../../../constants/enums'
import { get } from 'lodash'
import { mapAllActivitiesCategories } from '../../../redux/selectors/activities'

const enhance = compose(
    injectIntl,
    apiCodeLists(['awardLevelTypes', 'personStates', 'awardStates']),
    apiLeaders(),
    apiLabels(),
    apiOrganizations(),
    apiConfiguration(),
    permissionDeco(),
    connect(
        ({ api, auth }) => ({
          query: api.participants.assessor.activity.filter,
          awardStates: awardStatesFilterSelector(api.codeLists.awardStates.list),
          count: api.participants.assessor.activity.count,
          user: auth.user,
          activeOrganization: auth.organization
        }),
        { setFilter: participantsApi.setAssessorActivityParticipantsFilter }
    ),
    filter({
      form: 'participants-filter',
      persist: true,
      defaultFilter: {
        // eslint-disable-next-line camelcase
        personState_value: 'ACTIVE'
      }
    }),
 apiActivities({
  activityCategories: true
  }),
 injectIntl
)

class FilterAssessorActivityParticipants extends Component {
  static propTypes = {
    permissions: PropTypes.object.isRequired,
    codeLists: PropTypes.object.isRequired,
    awardStates: PropTypes.array.isRequired,
    leaders: PropTypes.object.isRequired,
    organizations: PropTypes.object.isRequired,
    getCustomLeaders: PropTypes.func.isRequired,
    searchLabels: PropTypes.func.isRequired,
    getCustomOrganizations: PropTypes.func.isRequired,
    count: PropTypes.number,
    user: PropTypes.object,
    intl: PropTypes.object.isRequired,
    activeOrganization: PropTypes.object.isRequired,
    configuration: PropTypes.object.isRequired
  }

  searchOrganizationAwardLeaders = search => {
    const { activeOrganization, user, intl } = this.props
    const params = { limit: 50 }

    if (search && search.name) {
      params.filter = `or(person.name ic ${search.name})`
    }

    return this.props.getCustomLeaders(activeOrganization.id, params, {
      onlyActive: true,
      disableQueryFilter: false
    })
        .then(obj => obj.body)
        .then(obj => mapLeaders({ list: obj }, user, intl, true))
  }

  searchOrganizationPersonLabels = search => {
    const params = { limit: 50 }

    if (search && search.name) {
      params.filter = `or(name ic ${search.name})`
    }

    const orgId = get(this.props.activeOrganization, 'id')
    return this.props.searchLabels(LABEL_CATEGORY_TYPES.PERSON.id, params, orgId)
        .then(obj => obj.body)
        .then(obj => mapLabels(obj))
  }

  searchAwardCentres = search => {
    const { activeOrganization } = this.props
    const params = { limit: 50 }

    if (search && search.name) {
      params.filter = `or(name ic ${search.name})`
    }

    return this.props.getCustomOrganizations(params,
        `flatHierarchy.parentOrganization.id=${activeOrganization.id},organizationHierarchyLevel.id=${ORGANIZATION_HIERARCHY.AU.id}`, {}, {
          onlyActive: true,
          disableLimit: false
        })
        .then(obj => obj.body)
        .then(obj => mapAwardUnits({ list: obj }))
  }

  render() {
    const { count, activities, intl, codeLists, awardStates, permissions, configuration, activeOrganization } = this.props

    const isLabelsEnabled = get(configuration, `valuesByOrganizationId[${activeOrganization.id}][${CONFIGURATION_KEYS.enableLabels.id}].booleanValue`)

    const mappedCategories = mapAllActivitiesCategories(
        activities.list,
        null,
        intl.formatMessage({
          id: 'label.other',
          defaultMessage: 'Other'
        })
    )

    return (
        <Module verticallyNarrow primary>
          <Row alignItems="center" gutters inner>
            <Col flex="0 1 120px">
              <Select
                  label="Level"
                  intlKey="label.level"
                  name="awards_awardLevel_value@or"
                  options={codeLists.awardLevelTypes.list}
                  multi
              />
            </Col>
            <Col flex="0 1 200px">
              <Input
                  label="Search"
                  intlKey="label.search"
                  name="id||name||email@ic"
                  clearable
              />
            </Col>
            <Col flex="0 1 120px">
              <Select
                  label="Participant status"
                  intlKey="label.participant_status"
                  options={codeLists.personStates.list}
                  name="personState_value"
              />
            </Col>
            <Col flex="0 1 200px">
              <Select
                  label="Award state"
                  intlKey="label.award_state"
                  options={awardStates}
                  name="awards_awardState_value@or"
                  searchable
                  multi
              />
            </Col>
            <Col flex="0 1 200px">
              <Select
                  label="Award Leader"
                  intlKey="label.award_leader"
                  name="awards_awardLeader_id@or"
                  multi
                  autocomplete
                  promise={this.searchOrganizationAwardLeaders}
                  placeholder="Start typing ..."
                  intlKeyPlaceholder="placeholder.start_typing"
                  backspaceToRemoveMessage={''}
              />
            </Col>
            {!permissions.isLeader && <Col flex="0 1 200px">
              <Select
                  label="Award Centre"
                  intlKey="label.award_unit"
                  name="awards_organization_id@or"
                  multi
                  autocomplete
                  promise={this.searchAwardCentres}
                  placeholder="Start typing ..."
                  intlKeyPlaceholder="placeholder.start_typing"
                  backspaceToRemoveMessage={''}
              />
            </Col>}
            {isLabelsEnabled && <Col flex="0 1 120px">
              <Select
                  label="Label"
                  intlKey="label.label"
                  name="labels_label_id@or"
                  multi
                  autocomplete
                  promise={this.searchOrganizationPersonLabels}
                  placeholder="Start typing ..."
                  intlKeyPlaceholder="placeholder.start_typing"
                  backspaceToRemoveMessage={''}
              />
            </Col>}

            <Col flex="0 1 200px">
              <Select
                  label="Activity Category"
                  intlKey="label.activity_category"
                  name="awards_activities_activityCategory_id"
                  searchable
                  options={mappedCategories}
              />
            </Col>

            <Col flex="1 1 auto" alignSelf="flex-end" right>
              <FilterActions
                  count={count}
                  {...this.props}
              />
            </Col>
          </Row>
        </Module>
    )
  }
}

export default enhance(FilterAssessorActivityParticipants)
